/* eslint-disable react/no-array-index-key */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const FormParamsTable = (props) => {
  const {
    arrayParam = [],
    paramFeature,
    onChangeAddPram,
    paramUnit,
    stateEdit,
  } = props;

  const checkInputValue = (value) => {
    if (value >= 6) {
      return false;
    }
    return true;
  };
  return (
    <form noValidate autoComplete="off">
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table" dense>
          <TableBody
            style={{
              justifyContent: 'center',
            }}
          >
            {arrayParam[paramFeature].length > 0 ? (
              arrayParam[paramFeature].map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell
                    key={`${row.id}+${index}`}
                    align="left"
                    padding="less"
                    // sortDirection={orderBy === headCell.id ? order : false}
                  >
                    {row[paramUnit]}
                  </TableCell>
                  <TableCell
                    key={`${row.id}+${index}`}
                    component="th"
                    scope="row"
                    align="rigth"
                    padding="none"
                  >
                    <TextField
                      disabled={stateEdit}
                      error={
                        paramUnit === 'atributo' && !checkInputValue(row?.valor)
                      }
                      onChange={(e) => onChangeAddPram(
                        paramFeature,
                        index,
                        row,
                        e.target.value,
                        'valor',
                      )}
                      margin="dense"
                      value={row?.valor}
                      helperText={
                        paramUnit === 'atributo' && !checkInputValue(row?.valor)
                          ? 'Valor incorrecto'
                          : ''
                      }
                      style={{ width: '100%' }}
                      type={paramUnit === 'atributo' ? 'number' : 'text'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {paramUnit === 'atributo' ? '0.1 ~ 5 -' : ''}
                          </InputAdornment>
                        ),
                      }}
                      id="outlined-basic"
                      label="Valor"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <h3>Crea un nuevo atributo para asignar una valoración</h3>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </form>
  );
};

export default FormParamsTable;
